import { initializeApp } from "firebase/app";
import {getAuth, GoogleAuthProvider} from 'firebase/auth'
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCKNX_S4QnkSHr0ci6nKJAJIv8615ENsvs",
  authDomain: "calidig-b0486.firebaseapp.com",
  projectId: "calidig-b0486",
  storageBucket: "calidig-b0486.appspot.com",
  messagingSenderId: "620768761857",
  appId: "1:620768761857:web:09ceac15d0c577dd990800",
  measurementId: "G-R47HPPWSXZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth =  getAuth(app);
export const googleProvider = new GoogleAuthProvider();